module.exports = function (str, length, omission) {
  if (str !== null && str.length > length) {
    return str.substring(0, length - omission.length) + omission;
  } else {
    return str;
  }
};







